export const bodyEditorMap = (formValues: Record<string, any>, data: any) => {
  if (!formValues.body) {
    formValues.body = data.body;
    return formValues;
  }

  return formValues;
};
